import { Component, OnInit, Input } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import { ThemeService } from 'ng2-charts';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css'],
  providers: [ThemeService]
})
export class BarChartComponent implements OnInit {

  @Input()
  chartData: number[];
  @Input()
  barChartLabels: string[];
  @Input()
  chartLabel: string;

  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
            stepSize: 1
        }
      }
    }
  };
  barChartData: ChartDataset[];

  constructor() { }

  ngOnInit() {
    this.barChartData = [
      { data: this.chartData, label: this.chartLabel, backgroundColor: 'rgba(70, 190, 170,0.2)', borderColor:"rgba(70,190, 170)",borderWidth:1,hoverBackgroundColor: '#5ea599' }
    ];
  }

}
